import React, { useEffect, useState } from 'react';

import { useAppSelector } from '@core/hooks/appHooks';
import { selectVendor } from '@core/store/appSlice/appSlice';
import { DemmiFS } from '@subhanhabib/demmilib';

import { CSSBLOCK_SHOP_MANAGEMENT } from '../ShopManagement';
import ShopManagementImagesView from './_view';

const ShopManagementImages: React.FC = () => {
  const vendor = useAppSelector(selectVendor);
  const [images, setImages] = useState<DemmiFS.DemmiImageResource[]>([]);

  const setValues = (vendor: DemmiFS.Vendor) => {
    setImages(vendor.images);
  };

  useEffect(() => {
    if (vendor) setValues(vendor);
  }, [vendor]);

  return (
    <div className={`${CSSBLOCK_SHOP_MANAGEMENT}__content-wrapper`}>
      <ShopManagementImagesView images={images} setImages={setImages} />
    </div>
  );
};

export default ShopManagementImages;
